<template>
  <div class="ui-date-picker">
    <div class="ui-date-picker__field">
      <date-picker
        :locale="locale"
        :value="dateValue"
        :popover="{ placement: 'top', visibility: 'click' }"
        :attributes="attributes"
        :mode="mode"
        @popoverWillShow="onFocus"
        @popoverWillHide="onBlur"
        @input="onInput"
      >
        <input
          :id="id"
          slot-scope="{ inputProps, inputEvents }"
          class="ui-date-picker__field__input"
          :class="{
            'ui-date-picker__field__input--icon-left': icon && !reverse,
            'ui-date-picker__field__input--icon-right': icon && reverse,
            'ui-date-picker__field__input--error': error,
          }"
          :placeholder="hideLabel ? label : ' '"
          v-bind="inputProps"
          v-on="inputEvents"
          :autocomplete="autocomplete ? 'on' : 'off'"
          :disabled="disabled"
        />
      </date-picker>
      <span
        class="ui-date-picker__field__icon backoffice-icons"
        :class="{
          'ui-date-picker__field__icon--left': icon && !reverse,
          'ui-date-picker__field__icon--right': icon && reverse,
          'ui-date-picker__field__icon--error': error,
        }"
        v-if="icon"
      >
        {{ icon }}
      </span>
      <label
        :for="id"
        class="ui-date-picker__field__label"
        :class="{
          'ui-date-picker__field__label--focused': hasDate,
          'ui-date-picker__field__label--icon-left': icon && !reverse,
          'ui-date-picker__field__label--icon-right': icon && reverse,
          'ui-date-picker__field__label--error': error,
          'ui-date-picker__field__label--hidden': hideLabel,
        }"
      >
        {{ label }}
      </label>
    </div>
    <div class="ui-date-picker__helper" :class="{ 'ui-date-picker__helper--error': error }">
      <slot>{{ helper }}</slot>
    </div>
  </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'UiDatePicker',
  components: {
    DatePicker,
  },
  model: {
    prop: 'dateValue',
  },
  props: {
    dateValue: {
      type: [String, Date, Object],
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    hideLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
    helper: {
      type: String,
      required: false,
      default: '',
    },
    reverse: {
      type: Boolean,
      required: false,
      default: false,
    },
    attributes: {
      type: Array,
      required: false,
      default: () => [
        {
          key: 'today',
          dot: true,
          dates: new Date(),
        },
      ],
    },
    locale: {
      type: String,
      required: false,
      default: 'en',
    },
    mode: {
      type: String,
      required: false,
      default: '',
    },
    autocomplete: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      hasDate: false,
    }
  },
  methods: {
    onInput(value) {
      const date = value ? value : ''
      /**
       * Emitted when the date of the input changed.
       * @event input
       * @type {Event}
       */
      this.$emit('input', date)
    },
    onFocus() {
      this.hasDate = true
    },
    onBlur() {
      this.hasDate = !!this.dateValue
    },
  },
}
</script>

<style lang="scss">
.ui-date-picker {
  &__field {
    position: relative;

    &__input {
      @include input;
    }

    &__label {
      @include input-label;
    }

    &__icon {
      @include input-icon;
    }
  }

  &__helper {
    @include input-helper;
  }
}
</style>
